import { createTheme } from '@mui/material';

// Create a custom theme with the new color palette from reference/App.js
const theme = createTheme({
  palette: {
    primary: {
      main: '#2D3142', // Dark color for primary elements
    },
    secondary: {
      main: '#E63946', // Accent color for highlights/secondary elements
    },
    background: {
      default: '#f5f5f5', // Light gray for app background
      paper: '#ffffff', // White for paper components
    },
  },
  // Optional: customize typography and other theme properties
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  // Add consistent border radius throughout the app
  shape: {
    borderRadius: 12, // Moderately rounded corners - single source of truth
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          margin: 0,
          padding: 0,
          height: '100%',
        },
        body: {
          margin: 0,
          padding: 0,
          height: '100%',
          backgroundColor: '#f5f5f5',
          '&:before': {
            content: '""',
            display: 'block',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
          }
        },
        '#root': {
          minHeight: '100vh',
        }
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius, // Reference the theme's borderRadius
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius, // Reference the theme's borderRadius
        }),
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius * 0.8, // Slightly less rounded
        }),
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: theme.shape.borderRadius * 0.65, // For progress bars
        }),
      },
    },
  },
});

export default theme;
